<template>
	<div>
		<div class="top-main-img" v-if="imgs.length > 0">
			<img :src="$imgUrl + imgs[0]" alt="" style="width: 100%; height: 100%;">
		</div>
		<div class="middel-box">
			<div class="img-list">
				<div class="img-box" v-for="(item, index) in imgs.slice(1, 4)">
					<img :src="$imgUrl + item" alt="" style="width: 100%; height: 100%;">
				</div>
			</div>
			<div class="ztjj">
				<div class="ztjj-title">
					<div class="left-line"></div>
					<div style="margin: 0 20px; font-size: 33px;">
						专题简介
					</div>
					<div class="right-line"></div>
				</div>
				<div class="ztjj-details" v-html="details.txt">
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				topicId: '',
				details: {},
				imgs: []
			}
		},
		created() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			this.topicId = this.$route.query.topic_id
			this.getDetails()

		},
		methods: {
			getDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.topicId
					}
				}).then(res => {
					if(res.code === 'S200') {
						that.details = res.data
						if(that.details.txt) {
							that.format()
						}
						if(res.data.listImgPc) {
							that.$store.state.showTopImage = true
							that.$store.state.topImage = that.$imgUrl + res.data.listImgPc
						} else {
							that.$store.state.showTopImage = false
							that.$store.state.topImage = ''
						}
						that.imgs = res.data.imgs.split(',')
						console.log(that.imgs);
					}
				})
			},
			format() {
				var html = this.details.txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:800px;height:auto;display:inline-block;margin:10rpx auto;"');
				this.details.txt = newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.top-main-img {
		width: 100%;
	}
	.middel-box {
		width: 100%;
		padding: 60px 112px;
		background-color: #bbb;
		display: flex;
		justify-content: space-between;
		.img-list {
			width: 36%;
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			.img-box {
				width: 100%;
				height: 31%;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		.ztjj {
			width: 60%;
			.ztjj-title {
				height: 70px;
				line-height: 70px;
				text-align: center;
				color: #922627;
				display: flex;
				justify-content: center;
				.left-line {
					height: 4px;
					margin-top: 33px;
					width: 30%;
					background-image: linear-gradient(to right, #bbb 0%, #922627 100%);
					border-radius: 4px;
				}
				.right-line {
					height: 4px;
					margin-top: 33px;
					width: 30%;
					background-image: linear-gradient(to right, #922627 0%, #bbb 100%);
					border-radius: 4px;
				}
			}
		}
	}
	.back {
		position: relative;
		margin: 30px 0 10px;
		width: 74;
		margin: 30px 13%;
		height: 20px;
		.back-button {
			position: absolute;
			width: 75px;
			height: 20px;
			line-height: 20px;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			right: 28px;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/collection_essence/ztsc_xqy.vue